export default __webpack_public_path__ + "static/media/J.8702b32d.svg";